const lengthTip = ({max,min,suffix=""}) => {
  if(max && min) {
    return `${min}~${max}`+ suffix
  }
  if(max && !min) {
    return `最长${max}`+ suffix
  }
  if(!max && min) {
    return `最短${min}` + suffix
  }
}
const must= (res) => {
  const {msg} = res
  return msg+'必填';
}
const fns = {
  lengthTip,
  must
}
export default fns
